<template>
  <v-app id="signup-agent-app">
    <div class="signup-agent-container">
      <!-- Logo Section -->
      <div class="logo-section">
        <img v-if="logoExists" src="/logo.png" alt="AutoSyncX" class="logo" />
        <h1 v-else class="logo-text">AutoSyncX</h1>
      </div>

      <!-- Agent Contact Modal -->
      <div class="agent-modal-wrapper">
        <AgentContactModal
          :is-open="true"
          :mode="'chat'"
          :user-id="null"
          @close="handleClose"
          @signup-complete="handleSignupComplete"
        />
      </div>
    </div>
  </v-app>
</template>

<script>
import AgentContactModal from '@/components/Agents/AgentContactModal.vue';
import Vue from 'vue';

export default {
  name: 'SignupAgent',
  components: {
    AgentContactModal
  },
  data() {
    return {
      logoExists: false
    };
  },
  methods: {
    handleClose() {
      // Redirect to referral program page when closed
      this.$router.push('/referral-program');
    },
    
    handleSignupComplete(userData) {
      console.log('Agent signup completed:', userData);

      Vue.$toast.success('🎉 Registration completed successfully! Check your email for login credentials.', {
        position: 'top-right',
        duration: 5000
      });

      // Log referral link for debugging
      if (userData.referral_link) {
        console.log('Referral link:', userData.referral_link);
      }

      // Stay on the same page - no redirect
      // User can close the modal to go back to referral program page
    },
    
    checkLogo() {
      // Check if logo exists
      const img = new Image();
      img.onload = () => {
        this.logoExists = true;
      };
      img.onerror = () => {
        this.logoExists = false;
      };
      img.src = '/logo.png';
    }
  },
  mounted() {
    this.checkLogo();
  },
  beforeCreate() {
    // Redirect if already logged in
    if (localStorage.getItem('token')) {
      if (localStorage.getItem('is_admin') && localStorage.getItem('is_admin') == 1) {
        this.$router.push('/admin/dashboard');
      } else {
        this.$router.push('/dashboard');
      }
    }
  }
};
</script>

<style scoped>
.signup-agent-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 25%, #0f3460 50%, #533483 75%, #7b2869 100%);
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.signup-agent-container::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(255, 64, 129, 0.3) 0%, transparent 70%);
  border-radius: 50%;
  filter: blur(60px);
}

.signup-agent-container::after {
  content: '';
  position: absolute;
  bottom: -30%;
  left: -10%;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(138, 43, 226, 0.3) 0%, transparent 70%);
  border-radius: 50%;
  filter: blur(60px);
}

.logo-section {
  margin-bottom: 30px;
  z-index: 1;
}

.logo {
  height: 80px;
  width: auto;
}

.logo-text {
  font-size: 36px;
  font-weight: bold;
  color: white;
  margin: 0;
}

.agent-modal-wrapper {
  width: 100%;
  max-width: 900px;
  z-index: 1;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .logo {
    height: 60px;
  }
  
  .logo-text {
    font-size: 28px;
  }
  
  .signup-agent-container {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .logo {
    height: 50px;
  }
  
  .logo-text {
    font-size: 24px;
  }
  
  .logo-section {
    margin-bottom: 20px;
  }
}
</style>

